import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import actions from 'state/actions';
import services from 'services';
import axios from 'axios';

const DeleteReportNotification = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const selectedRow = useSelector(selectors.configurator.getSelectedReportSettings);
  const rows = useSelector(selectors.configurator.getListOfReportSettings);
  const formMode = useSelector(selectors.configurator.getFormModeReports);

  const deleteRow = async () => {
    if (!selectedRow) return;
    try {
      await services.deleteScheduledNotificationSetting(selectedRow?.idSetting);
      dispatch(
        actions.configurator.setListOfReportSettings(
          (rows as any[]).filter((row) => row.idSetting !== selectedRow?.idSetting),
        ),
      );
      utils.app.notify('success', t('delete_report_success'));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        utils.app.notify('fail', `${t('error')} ${error.response}`);
        return;
      }
      console.error(error);
    } finally {
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <CommonButton
      id="delete-report-notification"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.DELETE_CONFIRMATION,
            props: {
              subtitle: t('delete-report-setting'),
              func: async () => await deleteRow(),
            },
          }),
        )
      }
      scope="tertiary"
      value={t(actionType.DELETE_REPORTS_NOTIFICATION)}
      customIcon="trash"
      disabled={
        !utils.user.isActionByCompanyActive(actionType.DELETE_REPORTS_NOTIFICATION) || !selectedRow || !!formMode
      }
    />
  );
};

export default DeleteReportNotification;
